"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { languages } from "../app/i18n/settings";

const languageNames = {
  en: "English",
  th: "ไทย",
  ja: "日本語",
  ko: "한국어",
  zh: "中文",
};

const flagEmojis = {
  en: "🇬🇧",
  th: "🇹🇭",
  ja: "🇯🇵",
  ko: "🇰🇷",
  zh: "🇨🇳",
};

const LanguageSwitcher = ({ currentLang, className }) => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (newLang) => {
    if (typeof window !== "undefined") {
      const currentPath = window.location.pathname;
      const currentSearchParams = new URLSearchParams(window.location.search);

      // Set the new language as a query parameter
      currentSearchParams.set('lng', newLang);

      // Construct the new URL
      const newPath = `${currentPath}?${currentSearchParams.toString()}`;

      router.push(newPath);
      setIsOpen(false);
    }
  };

  return (
    <div className={className}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white rounded-md px-3 py-2 transition-colors duration-200"
      >
        <span>{flagEmojis[currentLang]}</span>
        <span>{languageNames[currentLang]}</span>
        <svg
          className={`h-5 w-5 transform ${isOpen ? "rotate-180" : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 py-2 w-48 bg-white rounded-md shadow-xl z-20">
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => handleChange(lang)}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
            >
              <span className="mr-2">{flagEmojis[lang]}</span>
              {languageNames[lang]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
